import React from "react";

import { Stack, Typography } from "@mui/material";

interface CaptionedImageProps {
  src: string;
  alt: string;
  caption?: string;
  maxWidth?: number | string;
}

// A boxed, captioned image for illustrating help instructions
const CaptionedImage: React.FC<CaptionedImageProps> = ({ src, alt, caption, maxWidth = 600 }) => {
  return (
    <Stack
      spacing={1}
      alignItems="center"
      sx={{
        p: 1.5,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        width: "fit-content",
      }}
    >
      <img src={src} alt={alt} style={{ maxWidth, width: "100%" }} />
      {caption && (
        <Typography variant="caption" color="text.secondary" sx={{ textAlign: "center" }}>
          {caption}
        </Typography>
      )}
    </Stack>
  );
};

export default CaptionedImage;
